(function () {
    'use strict';

    angular.module('ib-components-module', [
        'ib-box-module',
        'ib-http-services-module',
        'ib-hover-opacity-module',
        'ib-gender-popover-module',
        'ib-tab-panel-module',
        'ib-ui-selectize-module',
        'ib-view-more-old-module',
        'ib-list-checkin-module',
        'ib-affix-module',
        'ib-accordion-module',
        'ib-cki-modal-module',
        'ib-validation-module',
        'ib-collapse',
        'ib-collapse-details-module',
        'ib-boarding-card-check-module',
        'ib-booking-name',
        'ib-calculate-height-module',
        'ib-pinch-zoom-module',
        'ib-main-header-module',
        'ib-checkin-dates-module',
        'ib-comment-module',
        'ib-checkin-main-footer-module',
        'ib-anonymous-search-module',
        'ib-equal-height-module',
        'ib-banner-module',
        'ib-view-more-module',
        'ib-scroll-module',
        'ib-element-scroll-module',
        'ib-segment-info-pa-module',
        'ib-tabs',
        'ib-ui-prefix-country-module',
        'ib-passenger-components-module',
        'ib-header-resize-module',
        'ib-http-services-module',
        'ib-monetate-module',
        'ib-content-parser-module',
        'ib-booking-popover-module',
        'ib-toggle-switch',
        'ib-focusin',
        'ib-boarding-cards-loading-module'
    ]);
})();
